<template>
  <modal name="patient-append-modal"
         :width="`100%`"
         :height="480"
         :min-width="450"
         :min-height="480"
         :pivotX="0.5"
         :pivotY="0.5"
         :delay="100"
         :draggable="false"
         @before-open="beforeOpen"
  >
    <LoadingOverlay
        :activeSyncProps="activeSync"
        :is-full-page-props="true"
    />
    <vue-scroll>
    <div class="FloatMenu md_overlay md_overlay_0">
      <div class="modal modal_0">
        <div
            class="md_content"
            :style="`height:${codeRegister ? 480 : 430}px; width:450px`"
        >
          <div class="popup_title">
            <h6 class="--blue70">{{ $t('patients.add.name') }}</h6>
          </div>
          <span
              @click="modalClose"
              class="md_close"
          >
            <img
                src="/images/union.svg"
                alt=""
            />
          </span>
          <PatientRegister
              v-if="register === undefined || register === true"
              :codeRegister="codeRegister"
              @insertPatient="insertPatient"
          />
          <PatientNotRegister
              v-else
          />
        </div>
      </div>
    </div>
    </vue-scroll>
  </modal>
</template>
<script>
import PatientRegister from './patientRegister'
import PatientNotRegister from './patientNotRegister'
import _API from '@/api'
import {mapActions, mapGetters} from 'vuex'
import LoadingOverlay from "@/components/loadingOverlay/index";

export default {
  name: 'PatientAppendModal',
  components: {
    LoadingOverlay,
    PatientRegister,
    PatientNotRegister,
  },
  data() {
    const codeRegister = this.getCheckTimeZone();

    return {
      activeSync: false,
      register: undefined,
      codeRegister: codeRegister,
    }
  },
  methods: {
    ...mapActions([
      'appendPatientIntoPatientList',
      'inspectSelectPatient'
    ]),
    ...mapGetters([
      'getPatientList',
      'getLatestPurchaseInfo',
      'getCheckTimeZone',
    ]),
    modalClose: function (event) {
      this.$modal.hide('patient-append-modal');
      event?.stopPropagation();
      event?.preventDefault();
    },
    async insertPatient(data) {
      try {
        this.activeSync = true;
        const res = this.codeRegister ? await _API.PATIENT.addPatient(data) : await _API.PATIENT.addPatientNoAuth(data);
        if (res.data.isSuccess) {
          await this.appendPatientIntoPatientList({
            ...res.data.patient,
            isEnabled :1,
            check: true,
          }).catch(e => {
            this.activeSync = false;
            throw new Error(`[insertPatient]${e}`);
          });
          this.activeSync = false;
          this.$modal.hide('patient-append-modal');
          this.inspectSelectPatient(res.data.patient.seqPatient);
          await this.$router.push(`/patientList/details/info?id=${res.data.patient.seqPatient}`);
        } else if (res.status === 200 && !res.data.isSuccess) {
          if (res.data.failedCode === "MR0101" || res.data.failedCode === "PAT1020") {
            this.$modal.show('common-alert-modal', {
              messageType: 'short',
              message: 'account.email_already_exist'
            });
          } else if (res.data.failedCode === "PAT0202") {
            this.$modal.show('common-alert-modal', {
              messageType: 'short',
              message: 'alert.codeErrorPat0202'
            });
          } else {
            this.$modal.show('common-alert-modal', {
              messageType: 'short',
              message: 'alert.unexpected_error'
            });
          }
          this.activeSync = false;
        } else if (res.status === 400) {
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: 'alert.unexpected_error'
          });
          this.activeSync = false;
        } else {
          throw new Error(`unexpected status code return ${res.status}`);
        }
      } catch (e) {
        throw new Error(`[patientAppend][insertPatient]${e}`);
      }
    },
    beforeOpen() {
      // TODO: 운영 반영시 제거
      const live = process.env.VUE_APP_MODE === 'LIVE';
      if (live) {
        this.register = true;
      } else {
        let cnt = this.getLatestPurchaseInfo().paymentInfo.productPatientProfileLimit;
        cnt = cnt === undefined ? 30 : cnt
        this.register = cnt === 0 || cnt > this.getPatientList().filter(item => item.check === true)?.length;
      }
    },
  },
}
</script>
<style lang="scss">
//.pop_add_search {
//  width: 100%;
//  height: 50px;
//  background: var(--grey20) url('/images/ic/comm/ic-search.svg') 20px 15px no-repeat;
//  border-radius: 50px;
//  margin-top: 1rem;
//  cursor: default;
//
//  input {
//    height: 50px;
//    border: none;
//    text-indent: 55px;
//    background: none;
//    width: 100%;
//  }
//}

.popup_title {
  user-select: none;
}

.v--modal-overlay[data-modal='patient-append-modal'] {
  .md_overlay {
    background: none;

    .md_content {
      .vld-background {
        border-radius: 10px;
      }

      .photo_add_btn {
        display: block;
        width: 255px;
        float: right;
      }
    }
  }
}
</style>
